"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AddOnInstance = _interopRequireDefault(require("../model/AddOnInstance"));
var _Balance = _interopRequireDefault(require("../model/Balance"));
var _BilledServiceCallDataRecord = _interopRequireDefault(require("../model/BilledServiceCallDataRecord"));
var _BooleanValueAddedServiceInstance = _interopRequireDefault(require("../model/BooleanValueAddedServiceInstance"));
var _BundleInstance = _interopRequireDefault(require("../model/BundleInstance"));
var _DiscountInstance = _interopRequireDefault(require("../model/DiscountInstance"));
var _MediaPayPerViewInstance = _interopRequireDefault(require("../model/MediaPayPerViewInstance"));
var _MediaSubscriptionInstance = _interopRequireDefault(require("../model/MediaSubscriptionInstance"));
var _Message = _interopRequireDefault(require("../model/Message"));
var _ParameterizedValueAddedServiceInstance = _interopRequireDefault(require("../model/ParameterizedValueAddedServiceInstance"));
var _PlanInstance = _interopRequireDefault(require("../model/PlanInstance"));
var _RechargeInstance = _interopRequireDefault(require("../model/RechargeInstance"));
var _UnbilledServiceCallDataRecord = _interopRequireDefault(require("../model/UnbilledServiceCallDataRecord"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Service service.
* @module api/ServiceApi
* @version 3.0
*/
var ServiceApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new ServiceApi. 
  * @alias module:api/ServiceApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function ServiceApi(apiClient) {
    _classCallCheck(this, ServiceApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Get a list of service-level AddOn Product Instances
   * Get a list of all Add On Product Instances provisioned against the Service.<br>Note: will not return expired product instances<br>
   * @param {Number} accountId ID of the account
   * @param {Number} serviceId ID of the service
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/AddOnInstance>} and HTTP response
   */
  return _createClass(ServiceApi, [{
    key: "getServiceAddOnProductInstancesWithHttpInfo",
    value: function getServiceAddOnProductInstancesWithHttpInfo(accountId, serviceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceAddOnProductInstances");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceAddOnProductInstances");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_AddOnInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/productinstances-addons', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a list of service-level AddOn Product Instances
     * Get a list of all Add On Product Instances provisioned against the Service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/AddOnInstance>}
     */
  }, {
    key: "getServiceAddOnProductInstances",
    value: function getServiceAddOnProductInstances(accountId, serviceId) {
      return this.getServiceAddOnProductInstancesWithHttpInfo(accountId, serviceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get all Service Balances
     * Get a list of all the Balances for a Service.<br>The API will not return expired Balances but does include used-up Balances.<br>A comma-separated list of tags can be added to the API call as a parameter to get only Balances of certain types.<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Balance>} and HTTP response
     */
  }, {
    key: "getServiceBalancesWithHttpInfo",
    value: function getServiceBalancesWithHttpInfo(accountId, serviceId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceBalances");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceBalances");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Balance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/balances', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get all Service Balances
     * Get a list of all the Balances for a Service.<br>The API will not return expired Balances but does include used-up Balances.<br>A comma-separated list of tags can be added to the API call as a parameter to get only Balances of certain types.<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Balance>}
     */
  }, {
    key: "getServiceBalances",
    value: function getServiceBalances(accountId, serviceId, opts) {
      return this.getServiceBalancesWithHttpInfo(accountId, serviceId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List of billed usage.
     * Get a list of the billed (invoiced) usage on a service.<br>This API is specifically for postpaid usages that are included in the postpaid invoice.<br>The API is paginated with a default page size of 100 usages. The size of pagination can be controlled using the itemsPerPage parameter. Use the pageNumber parameter to go through multiple pages of the response.<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Object} opts Optional parameters
     * @param {String} [recordType = 'ALL')] Record Type
     * @param {Number} [pageNumber = 0)] Page Number Id
     * @param {Number} [itemsPerPage = 0)] Items per page
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/BilledServiceCallDataRecord>} and HTTP response
     */
  }, {
    key: "getServiceBilledUsageWithHttpInfo",
    value: function getServiceBilledUsageWithHttpInfo(accountId, serviceId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceBilledUsage");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceBilledUsage");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {
        'recordType': opts['recordType'],
        'pageNumber': opts['pageNumber'],
        'itemsPerPage': opts['itemsPerPage']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_BilledServiceCallDataRecord["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/usage/billed', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List of billed usage.
     * Get a list of the billed (invoiced) usage on a service.<br>This API is specifically for postpaid usages that are included in the postpaid invoice.<br>The API is paginated with a default page size of 100 usages. The size of pagination can be controlled using the itemsPerPage parameter. Use the pageNumber parameter to go through multiple pages of the response.<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Object} opts Optional parameters
     * @param {String} opts.recordType Record Type (default to 'ALL')
     * @param {Number} opts.pageNumber Page Number Id (default to 0)
     * @param {Number} opts.itemsPerPage Items per page (default to 0)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/BilledServiceCallDataRecord>}
     */
  }, {
    key: "getServiceBilledUsage",
    value: function getServiceBilledUsage(accountId, serviceId, opts) {
      return this.getServiceBilledUsageWithHttpInfo(accountId, serviceId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get service-level Boolean ValueAddedService Product Instances
     * Get a list of all Boolean ValueAddedService Products on the Service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/BooleanValueAddedServiceInstance>} and HTTP response
     */
  }, {
    key: "getServiceBooleanValueAddedServiceProductInstancesWithHttpInfo",
    value: function getServiceBooleanValueAddedServiceProductInstancesWithHttpInfo(accountId, serviceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceBooleanValueAddedServiceProductInstances");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceBooleanValueAddedServiceProductInstances");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_BooleanValueAddedServiceInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/productinstances-booleanvalueaddedservices', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get service-level Boolean ValueAddedService Product Instances
     * Get a list of all Boolean ValueAddedService Products on the Service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/BooleanValueAddedServiceInstance>}
     */
  }, {
    key: "getServiceBooleanValueAddedServiceProductInstances",
    value: function getServiceBooleanValueAddedServiceProductInstances(accountId, serviceId) {
      return this.getServiceBooleanValueAddedServiceProductInstancesWithHttpInfo(accountId, serviceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get service-level Bundle Product Instances
     * Get a list of all Bundle Product Instances on the Service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/BundleInstance>} and HTTP response
     */
  }, {
    key: "getServiceBundleProductInstancesWithHttpInfo",
    value: function getServiceBundleProductInstancesWithHttpInfo(accountId, serviceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceBundleProductInstances");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceBundleProductInstances");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_BundleInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/productinstances-bundles', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get service-level Bundle Product Instances
     * Get a list of all Bundle Product Instances on the Service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/BundleInstance>}
     */
  }, {
    key: "getServiceBundleProductInstances",
    value: function getServiceBundleProductInstances(accountId, serviceId) {
      return this.getServiceBundleProductInstancesWithHttpInfo(accountId, serviceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a list of service-level Discount Product Instances
     * Get a list of all Discount Product Instances on the Service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/DiscountInstance>} and HTTP response
     */
  }, {
    key: "getServiceDiscountProductInstancesWithHttpInfo",
    value: function getServiceDiscountProductInstancesWithHttpInfo(accountId, serviceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceDiscountProductInstances");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceDiscountProductInstances");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_DiscountInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/productinstances-discounts', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a list of service-level Discount Product Instances
     * Get a list of all Discount Product Instances on the Service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/DiscountInstance>}
     */
  }, {
    key: "getServiceDiscountProductInstances",
    value: function getServiceDiscountProductInstances(accountId, serviceId) {
      return this.getServiceDiscountProductInstancesWithHttpInfo(accountId, serviceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a list of service-level MediaPayPerView Product Instances
     * Get a list of all MediaPayPerView Product Instances on the service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Object} opts Optional parameters
     * @param {String} [status] status
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/MediaPayPerViewInstance>} and HTTP response
     */
  }, {
    key: "getServiceMediaPayPerViewProductInstancesWithHttpInfo",
    value: function getServiceMediaPayPerViewProductInstancesWithHttpInfo(accountId, serviceId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceMediaPayPerViewProductInstances");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceMediaPayPerViewProductInstances");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {
        'status': opts['status']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_MediaPayPerViewInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/productinstances-mediapayperviews', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a list of service-level MediaPayPerView Product Instances
     * Get a list of all MediaPayPerView Product Instances on the service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Object} opts Optional parameters
     * @param {String} opts.status status
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/MediaPayPerViewInstance>}
     */
  }, {
    key: "getServiceMediaPayPerViewProductInstances",
    value: function getServiceMediaPayPerViewProductInstances(accountId, serviceId, opts) {
      return this.getServiceMediaPayPerViewProductInstancesWithHttpInfo(accountId, serviceId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get MediaSubscription Product Instances
     * Get a list of all MediaSubscription Product Instances on the service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Object} opts Optional parameters
     * @param {String} [status] status
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/MediaSubscriptionInstance>} and HTTP response
     */
  }, {
    key: "getServiceMediaSubscriptionProductInstancesWithHttpInfo",
    value: function getServiceMediaSubscriptionProductInstancesWithHttpInfo(accountId, serviceId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceMediaSubscriptionProductInstances");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceMediaSubscriptionProductInstances");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {
        'status': opts['status']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_MediaSubscriptionInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/productinstances-mediasubscriptions', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get MediaSubscription Product Instances
     * Get a list of all MediaSubscription Product Instances on the service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Object} opts Optional parameters
     * @param {String} opts.status status
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/MediaSubscriptionInstance>}
     */
  }, {
    key: "getServiceMediaSubscriptionProductInstances",
    value: function getServiceMediaSubscriptionProductInstances(accountId, serviceId, opts) {
      return this.getServiceMediaSubscriptionProductInstancesWithHttpInfo(accountId, serviceId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get Parameterized ValueAddedService Product Instances
     * Get a list of all Parameterized ValueAddedService Product Instances on the service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ParameterizedValueAddedServiceInstance>} and HTTP response
     */
  }, {
    key: "getServiceParameterizedValueAddedServiceProductInstancesWithHttpInfo",
    value: function getServiceParameterizedValueAddedServiceProductInstancesWithHttpInfo(accountId, serviceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceParameterizedValueAddedServiceProductInstances");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceParameterizedValueAddedServiceProductInstances");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_ParameterizedValueAddedServiceInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/productinstances-parameterizedvalueaddedservices', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get Parameterized ValueAddedService Product Instances
     * Get a list of all Parameterized ValueAddedService Product Instances on the service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ParameterizedValueAddedServiceInstance>}
     */
  }, {
    key: "getServiceParameterizedValueAddedServiceProductInstances",
    value: function getServiceParameterizedValueAddedServiceProductInstances(accountId, serviceId) {
      return this.getServiceParameterizedValueAddedServiceProductInstancesWithHttpInfo(accountId, serviceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get Plan Product Instances
     * Get a list of all Plan Product Instances on the Service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/PlanInstance>} and HTTP response
     */
  }, {
    key: "getServicePlanProductInstancesWithHttpInfo",
    value: function getServicePlanProductInstancesWithHttpInfo(accountId, serviceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServicePlanProductInstances");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServicePlanProductInstances");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_PlanInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/productinstances-plans', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get Plan Product Instances
     * Get a list of all Plan Product Instances on the Service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/PlanInstance>}
     */
  }, {
    key: "getServicePlanProductInstances",
    value: function getServicePlanProductInstances(accountId, serviceId) {
      return this.getServicePlanProductInstancesWithHttpInfo(accountId, serviceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get Recharge Product Instances
     * Get a list of all Recharge Product Instances on the service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/RechargeInstance>} and HTTP response
     */
  }, {
    key: "getServiceRechargeProductInstancesWithHttpInfo",
    value: function getServiceRechargeProductInstancesWithHttpInfo(accountId, serviceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceRechargeProductInstances");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceRechargeProductInstances");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_RechargeInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/productinstances-recharges', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get Recharge Product Instances
     * Get a list of all Recharge Product Instances on the service.<br>Note: will not return expired product instances<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/RechargeInstance>}
     */
  }, {
    key: "getServiceRechargeProductInstances",
    value: function getServiceRechargeProductInstances(accountId, serviceId) {
      return this.getServiceRechargeProductInstancesWithHttpInfo(accountId, serviceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List of Unbilled usage.
     * Get a list of the unbilled (un-invoiced) usage on a service.<br>This API is specifically for postpaid usages, ones that are not included in the postpaid invoice.<br>The API is paginated with a default page size of 100 usages. The size of pagination can be controlled using the itemsPerPage parameter. Use the pageNumber parameter to go through multiple pages of the response.<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Object} opts Optional parameters
     * @param {String} [recordType = 'ALL')] Record Type
     * @param {Number} [pageNumber = 0)] Page Number Id
     * @param {Number} [itemsPerPage = 0)] Items per page
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/UnbilledServiceCallDataRecord>} and HTTP response
     */
  }, {
    key: "getServiceUnBilledUsageWithHttpInfo",
    value: function getServiceUnBilledUsageWithHttpInfo(accountId, serviceId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceUnBilledUsage");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceUnBilledUsage");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {
        'recordType': opts['recordType'],
        'pageNumber': opts['pageNumber'],
        'itemsPerPage': opts['itemsPerPage']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_UnbilledServiceCallDataRecord["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/usage/unbilled', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List of Unbilled usage.
     * Get a list of the unbilled (un-invoiced) usage on a service.<br>This API is specifically for postpaid usages, ones that are not included in the postpaid invoice.<br>The API is paginated with a default page size of 100 usages. The size of pagination can be controlled using the itemsPerPage parameter. Use the pageNumber parameter to go through multiple pages of the response.<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Object} opts Optional parameters
     * @param {String} opts.recordType Record Type (default to 'ALL')
     * @param {Number} opts.pageNumber Page Number Id (default to 0)
     * @param {Number} opts.itemsPerPage Items per page (default to 0)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/UnbilledServiceCallDataRecord>}
     */
  }, {
    key: "getServiceUnBilledUsage",
    value: function getServiceUnBilledUsage(accountId, serviceId, opts) {
      return this.getServiceUnBilledUsageWithHttpInfo(accountId, serviceId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();